/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimmedicareoutpatientadjudication extends IceEntity {
  claim_medicare_outpatient_adjudication_key: string = "";
  reimbursement_rate: number = 0.0;
  price: number = 0.0;
  remark1: string = "";
  remark2: string = "";
  remark3: string = "";
  remark4: string = "";
  remark5: string = "";
  esrd_paid_amount: number = 0.0;
  non_payble_billed_amount: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_MEDICARE_OUTPATIENT_ADJUDICATION";
  }
}

